import AllowComponentPermission from './allow-component-permission.hoc';
export default AllowComponentPermission;
